module.exports = __webpack_public_path__ + "img/mb_Account.2b8e51f2.svg";